module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_3016.c92684c4.png";